import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import ProfileComponent from '../components/Profile'
import { customerLogout } from '../../Account/actions/apiRequest'
import { showPasswordModal } from '../../ChangePassword/actions'

import '../styles/AccountDropdown.scss'

const mapStateToProps = (state) => ({
  customerData: {
    firstName: state.user.userName,
    isLoggedin: state.user.isUserLoggedIn,
  },
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleChangePassword: () => {
    dispatch(showPasswordModal())
  },
  onClickLogout: () => {
    dispatch(customerLogout(ownProps.history))
  },
})

const MyAccount = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileComponent)

export default withRouter(MyAccount)
